import { HomeCollectionHybrid } from '../queries/home_collection'

const initialFilters = {
  page: 1,
  per_page: 10,
  filters: { type: 'BrowseCollection' }
}

const collections = (
  page = initialFilters.page,
  per_page = initialFilters.per_page,
  filters = initialFilters.filters
) => ({
  type: 'API:COLLECTIONS_LIST:FETCH',
  API: true,
  method: 'POST',
  url: '/api/query',
  data: {
    query: HomeCollectionHybrid,
    variables: {
      page,
      per_page,
      filters
    }
  }
})

const clearCollections = () => ({
  type: 'COLLECTIONS_LIST:CLEAR'
})

export default {
  collections,
  clearCollections
}
